class SizeGuide extends HTMLElement {
  toggleSwitch?: HTMLElement | null;

  connectedCallback() {
    this.toggleSwitch = this.querySelector(".toggle-switch");
    this.toggleSwitch?.addEventListener("click", this.toggleCmInch.bind(this));
  }

  toggleCmInch() {
    const cells = this.querySelectorAll("td");

    this.toggleSwitch?.classList.toggle("active");

    cells.forEach((cell: HTMLElement) => {
      if (cell.dataset.originalValue) {
        if (this.toggleSwitch?.classList.contains("active")) {
          cell.innerText = (parseFloat(cell.dataset.originalValue) / 2.54).toFixed(1);
        } else {
          cell.innerText = cell.dataset.originalValue;
        }
      } else if (!isNaN(parseFloat(cell.innerText))) {
        cell.dataset.originalValue = cell.innerText;
        if (this.toggleSwitch?.classList.contains("active")) {
          cell.innerText = (parseFloat(cell.innerText) / 2.54).toFixed(1);
        }
      }
    });
  }
}

customElements.define("size-guide", SizeGuide);
